import { logError } from 'fergy-core-react-logging';
import { ACCOUNT_LOGIN_LINK } from '../../constants/links';
import { useCustomerLogout } from '../../hooks/apollo/authentication/authentication.hooks';
import { useCustomer } from '../../hooks/apollo/customer/customer.hooks';
import { useEmployee } from '../../hooks/apollo/employee/employee.hooks';
import { useNavigation } from '../../hooks/navigation/navigation.hooks';
import { ClickableElement } from '../buttons';
import { Link } from '../common-components/link/link.component';
import OmniProBadgeIconSvg from '../svgs/omni-pro-badge-icon.svg';

export const InternalCustomerBanner = () => {
	const { data: customerData, hasAccount, isPro } = useCustomer();
	const customerProfile = customerData?.customer?.profile;
	const { firstName = '', lastName = '' } = customerProfile || {};
	const { employee } = useEmployee();
	const { logout } = useCustomerLogout();
	const navigate = useNavigation();

	if (!employee.isAuthenticated) {
		return null;
	}

	const onLogoutCustomer = () => {
		logout()
			.then(() => {
				navigate(ACCOUNT_LOGIN_LINK);
			})
			.catch(logError)
			.finally(() => {});
	};

	return (
		<div className="w-full bg-utility-internal-alt text-white text-right py-2 md:py-3 pr-4 md:pr-6">
			<div className="max-w-7xl mx-auto text-sm/3.5!">
				{hasAccount ? (
					<div className="flex justify-end font-normal">
						<span className="pr-1 truncate">
							{firstName} {lastName}
						</span>
						{isPro && (
							<span className="pr-1 -my-2">
								<OmniProBadgeIconSvg aria-label="Omni Pro Badge" className="text-white text-3xl" />
							</span>
						)}
						<span className="">|</span>
						<ClickableElement
							ariaLabel="Log Out as Customer"
							className="underline pl-1 focus-visible:focus-ring focus-visible:outline-none! rounded-full"
							onClick={onLogoutCustomer}>
							Log Out
						</ClickableElement>
					</div>
				) : (
					<Link
						url={ACCOUNT_LOGIN_LINK}
						underline={true}
						className="text-white! focus-visible:focus-ring focus-visible:outline-none! rounded-full">
						Log In as Customer
					</Link>
				)}
			</div>
		</div>
	);
};
